<h1 mat-dialog-title class="header">{{ 'PIN-DELETE-DIALOG.DELETE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p class="description">{{ 'PIN-DELETE-DIALOG.DELETE-PIN' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="delete-confirm-pin" mat-flat-button  (click)="deletePin()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button class="delete-confirm-pin cancel-pin" mat-flat-button  (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
